import React from "react";

const GarrisonLink = ({to, navigate, children, className = "", title}) => {
    const content = children ?? "";

    if (!to || !navigate) return <span>{content}</span>;

    const onClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        navigate(to.dev, true);
    };

    return (
        <button
            type="button"
            className={["a-link cursor-pointer", className].filter(Boolean).join(" ")}
            title={title}
            onClick={onClick}
        >
            {content}
        </button>
    );
};

export default GarrisonLink;
